
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../../home/components/Footer';

export default function AboutCTA() {
  const navigate = useNavigate();

  return (
    <>
      <section className="py-24 px-6 bg-white">
        <div className="max-w-[1200px] mx-auto">
          <div className="relative overflow-hidden rounded-2xl border border-[#14B8A6]/20 bg-gradient-to-br from-[#F0FDFA] via-white to-[#FFF7ED] p-16 text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              了解更多或开始使用
            </h2>
            <p className="text-gray-500 mb-10 max-w-xl mx-auto">
              无论是了解平台能力、咨询技术对接，还是探讨商务合作，我们随时准备好。
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <button
                onClick={() => navigate('/capabilities')}
                className="px-8 py-3 bg-gradient-to-r from-[#0D9488] to-[#14B8A6] text-white rounded-full hover:scale-105 transition-transform cursor-pointer whitespace-nowrap font-medium shadow-md shadow-teal-100"
              >
                了解平台能力
              </button>
              <button
                onClick={() => navigate('/compliance')}
                className="px-8 py-3 border border-[#14B8A6] text-[#14B8A6] rounded-full hover:bg-[#14B8A6] hover:text-white transition-all cursor-pointer whitespace-nowrap font-medium"
              >
                咨询技术对接
              </button>
              <button
                onClick={() => navigate('/scenarios')}
                className="px-8 py-3 border border-gray-300 text-gray-600 rounded-full hover:border-gray-500 hover:text-gray-800 transition-all cursor-pointer whitespace-nowrap font-medium"
              >
                商务合作
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
